import { useLocation } from 'react-router-dom';
import { Flex, useToast } from '@chakra-ui/react';
import { useEffect } from 'react';
import axios from 'axios';
import { DefaultLayout } from '../../../_layout/DefaultLayout';
import { showUsersService } from '../../../../../services/Users/ShowUsersService';
import { translateError } from '../../../../../utils/errors';
import { useUser } from '../../../../../hooks/user';
import GuestDetailsData from './components/GuestDetailsData';
import { GuestDetailsInfo } from './components/GuestDetailsInfo';

interface ILocationState {
  guestId: string;
}

export const GuestDetails = (): JSX.Element => {
  const toast = useToast();
  const { handleUser: handleGuest, user: guest } = useUser();

  const {
    state: { guestId },
  } = useLocation<ILocationState>();

  useEffect(() => {
    async function loadGuest(): Promise<void> {
      try {
        const guestData = await showUsersService(guestId);

        handleGuest(guestData);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status !== 401) {
          toast({
            title: 'Falha ao carregar dados',
            description:
              translateError({ message: err.response?.data.message }) ||
              'Ocorreu um erro ao carregar os detalhes do convidado, tente novamente.',
            status: 'error',
            duration: 3000,
            isClosable: true,
            variant: 'subtle',
            position: 'top-right',
          });
        }
      }
    }

    loadGuest();

    return () => handleGuest(undefined);
  }, [guestId, handleGuest, toast]);

  return (
    <DefaultLayout>
      {guest && (
        <Flex direction="column" w="100%">
          <GuestDetailsInfo minW="510px" />

          <GuestDetailsData flex="1" mt="8" minW="510px" />
        </Flex>
      )}
    </DefaultLayout>
  );
};
